import React, { useState, useEffect } from "react";
import { GiFairyWings } from "react-icons/gi";
import { FaFileAlt } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import axiosInstance from "../../../api/axiosInstance"; 
import "./PratibhaKhojPariksha.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://localhost:5000";

const PratibhaKhojPariksha = () => {
  const [activeForm, setActiveForm] = useState(null);

  useEffect(() => {
    const fetchActiveForm = async () => {
      try {
        const response = await axiosInstance.get('/api/pratibha-khoj-forms/public/active');
        if (response.data) {
          setActiveForm(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch active form", error);
      }
    };

    fetchActiveForm();
  }, []);

  return (
    <>
      <Helmet>
        <title>Pratibha Khoj Pariksha | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Pratibha Khoj Pariksha information for Rajput Shiksha Kosh, outlining the details and rules for the examination."
        />
      </Helmet>
    <section className="pratibha-khoj-pariksha-wrapper">
      <div className="pratibha-khoj-pariksha-header">
        <h2 className="pratibha-khoj-pariksha-title">Pratibha Khoj Pariksha</h2>
        <div className="pratibha-khoj-pariksha-divider">
          <span className="pratibha-khoj-pariksha-line"></span>
          <GiFairyWings className="pratibha-khoj-pariksha-icon" />
          <span className="pratibha-khoj-pariksha-line"></span>
        </div>
      </div>

      <div className="pratibha-khoj-pariksha-container">
        <div className="pratibha-khoj-pariksha-main-box">
          
          <div className="pratibha-khoj-pariksha-intro">
            <h3 className="pratibha-khoj-pariksha-sub-heading">राजपूत प्रतिभा खोज परीक्षा</h3>
            <p className="pratibha-khoj-pariksha-office-info">(कार्यालय - मारवाड़ राजपूत सभा भवन, पावटा 'बी' रोड, जोधपुर )</p>
            <p className="pratibha-khoj-pariksha-para">
              राजपूत समाज ने अभावग्रस्त राजपूत भाइयो के परिवारों के प्रतिभावान बालको की भावी शिक्षा को सुनिशिचत करने हेतु एक राजपूत शिक्षा कोष का गठन किया है। जिसके ब्याज एंव लाभांश से इन जरूरतमंद प्रतिभा संपन्न बालको की शिक्षा व्यवस्था नियमित स्थाई रूप की जा सकेगी। राजपूत समाज के निजी विद्यालय संचालक भी इस परीक्षा के माध्यम से जरूरतमंद प्रतिभावान छात्रों को इस परीक्षा के द्वारा चयनित छात्रों को निशुल्क शिक्षण का अवसर प्रदान करेंगे। 
            </p>
            <p className="pratibha-khoj-pariksha-para">
              माध्यमिक शिक्षा वर्ग के अभावग्रस्त एंव प्रतिभावान बालको की प्रतिभा की खोज हेतु गत वर्ष की तरह इस वर्ष भी जून के दूसरे रविवार को होना निशिचत हुआ है। अति प्रसन्नता का विषय है की इस वर्ष जोधपुर संभाग के सभी जिलों में पृथक-पृथक राजपूत बालक-बालिकाओ की प्रतिभा खोज परीक्षा प्रत्येक जिला मुख्यालय पर आयोजित की जावेगी।
            </p>
          </div>

          <div className="pratibha-khoj-pariksha-rules-section">
            <h4 className="pratibha-khoj-pariksha-section-title">परीक्षा संबंधी नियम</h4>
            <div className="pratibha-khoj-pariksha-list">
              {[
                "परीक्षा में कक्षा 6,7,8, एंव 9, में प्रवेश के पात्र विद्यार्थी भाग ले सकेंगे।",
                "परीक्षा राजपूत समाज के एक लाख रुपये वार्षिक आय वाले ही भाग लेंगे।",
                "परीक्षा हेतु पाठ्यक्रम में गणित, अंग्रेजी, विज्ञान, सामाजिक ज्ञान, (सामान्य ज्ञान) विषय के 25-25 अंक के प्रश्न पूछे जायेंगे।",
                "परीक्षा 100 अंक की होगी। परीक्षा OMR sHEET में होगी। परीक्षा का समय 2 घंटे होगा।",
                "परीक्षा में कक्षा 6 में पांच छात्र, परीक्षा में कक्षा 7 में दो, कक्षा 8 में दो, कक्षा 9 में दो, कुल 11 छात्रों का चयन मेरिट व पात्रता के अनुसार चयन किया जायेगा। जिनका शिक्षा का पूरा ख़र्च राजपूत शिक्षा कोष द्वारा उठाया जायेगा।",
                "परीक्षा द्वारा प्रत्येक उपरोक्त जिलों में निजी राजपूत विद्यालयों में जिला मेरिट के अनुसार अध्ययन का अवसर प्रदान किया जावेगा।",
                "चयनित छात्र अपनी सुविधा अनुसार इच्छित विद्यालय में अध्ययन क्र सकेंगे। जिसका भुगतान राजपूत शिक्षा कोष द्वारा किया जावेगा।",
                "निजी राजपूत विद्यालयों में अध्ययन हेतु चयन छात्रों को विद्यालय में उपलब्ध सुविधांए (स्कूल फीस, स्कूल ड्रेस, पाठ्यपुस्तके) प्रदान की जायगी, हॉस्टल सुविधा विद्यालय में उपलब्ध होने पर ही मिलेगी।",
                "फॉर्म एंव परीक्षा संबंधी अन्य समस्त जानकारी वेबसाइट www.rajputshikshakosh.com पर भी उपलब्ध है। परीक्षा में भाग लेने हेतु पूर्ण भरा हुआ फॉर्म E-mail - rajputshikshakosh@gmail.com पर भी भेजे जा सकते है।"
              ].map((rule, index) => (
                <div className="pratibha-khoj-pariksha-item" key={index}>
                  <span className="pratibha-khoj-pariksha-number">{index + 1}</span>
                  <p>{rule}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="pratibha-khoj-pariksha-coordinator">
            <h5>श्याम सिंह सजाडा</h5>
            <p>(क्षेत्रीय परीक्षा समन्यवक)</p>
            <p className="phone">मो. न. - 9414110437</p>
          </div>

          {/* DYNAMIC BUTTON - NO TITLE */}
          <div className="pratibha-khoj-pariksha-action">
            {activeForm ? (
                <a 
                  href={`${API_BASE_URL}${activeForm.fileUrl}`} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="pratibha-khoj-pariksha-btn"
                >
                  <FaFileAlt className="btn-icon" /> Pratibha Khoj Pariksha Form
                </a>
            ) : (
                <button className="pratibha-khoj-pariksha-btn" style={{ opacity: 0.6, cursor: "not-allowed" }} disabled>
                   <FaFileAlt className="btn-icon" /> Form Currently Not Available
                </button>
            )}
          </div>

        </div>
      </div>
    </section>
    </>
  );
};

export default PratibhaKhojPariksha;